import type { MissionSubmission } from '../types/mission'

function submittedAt(submission: MissionSubmission): number | null {
  if (!submission.created_at) return null
  const time = Date.parse(submission.created_at)
  return Number.isNaN(time) ? null : time
}

// `created_at` quando os dois lados têm data utilizável; `id` como desempate.
// Misturar epoch com id na mesma comparação daria ordem arbitrária.
function isNewer(a: MissionSubmission, b: MissionSubmission): boolean {
  const timeA = submittedAt(a)
  const timeB = submittedAt(b)

  if (timeA !== null && timeB !== null) return timeA > timeB

  return a.id > b.id
}

function mostRecent(
  submissions: MissionSubmission[]
): MissionSubmission | undefined {
  return submissions.reduce<MissionSubmission | undefined>(
    (latest, current) =>
      latest === undefined || isNewer(current, latest) ? current : latest,
    undefined
  )
}

export function resolveMissionSubmission(
  submissions: MissionSubmission[]
): MissionSubmission | undefined {
  return (
    submissions.find(sub => sub.status === 'approved') ||
    submissions.find(sub => sub.status === 'pending') ||
    // Recusas se acumulam (o reenvio cria linha nova em vez de reaproveitar a
    // recusada), e é a última que carrega o motivo que o aluno precisa ler.
    // Pegar a primeira do array mostraria o motivo de uma recusa já superada.
    mostRecent(submissions.filter(sub => sub.status === 'refused')) ||
    submissions[0]
  )
}
